export default function XboxLogo({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 120 120"
      className={className}
    >
      <path fill="#107c10" d="M0 0h120v120H0z" />
      <g className="cls-3" data-name="Xbox 2020 Sphere">
        <g className="cls-3">
          <path
            d="M60 52.18s.08 0 .12.08c11.86 9 32.14 31.31 25.95 37.58a39.64 39.64 0 0 1-52.18 0c-6.23-6.31 14.09-28.61 26-37.58.08 0 .12-.08.16-.08m20.62-26.03a39.56 39.56 0 0 0-41.34 0 .15.15 0 0 0-.08.2c0 .08.12.08.19.08 7.66-1.67 19.37 5 20.44 5.63a.12.12 0 0 0 .16 0c1.11-.67 12.74-7.3 20.44-5.63a.14.14 0 0 0 .19-.08.13.13 0 0 0 0-.2m-48.41 5.6a.55.55 0 0 0-.16.12A39.62 39.62 0 0 0 28.49 84c0 .08.12.08.2.08s.08-.12 0-.2c-3-9.33 12.42-32 20.44-41.47a.15.15 0 0 0 0-.12s0-.12-.08-.12C37.06 30.12 32.94 31.39 32.26 31.75m38.61 10.39s-.08.08-.08.12v.12c7.94 9.49 23.42 32.14 20.44 41.47v.2a.15.15 0 0 0 .2-.08 39.71 39.71 0 0 0-3.53-52.14l-.16-.12c-.68-.32-4.8-1.59-16.87 10.43"
            className="cls-4"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}